import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({


    buttonNavBar: {
        overflow: "auto",
        width: "100%"
    },

    courseButton: {
        color: "black",
        backgroundColor: "white",
        '&:hover': {
            backgroundColor: "#f2f2f2",
        }
    },

    activeCourseButton: {
        color: "black",
        backgroundColor: "#3b8df1",
        '&:hover': {
            backgroundColor: "#589ef3",
        }
    },

    playlistContainer: {

        paddingLeft: "20px",
        paddingRight: "20px"

    },

    root: {

        display: 'flex',
        flexWrap: 'wrap',
        '& > *': {
            margin: theme.spacing(1),
            width: theme.spacing(16),
            height: theme.spacing(16),
        },
    },

    paperStart: {
        display: 'flex',
        flexWrap: 'wrap',
        backgroundColor: "#add8e6",
        minWidth: 150,
        minHeight: 200,
        '&:hover': {
            backgroundColor: "#3b8df1",
            '& $icon': {
                color: "#ffffff"
            },
            '& $content': {
                color: "#ffffff"
            },
            '& $btn': {
                backgroundColor: "#0057d8",
                color: "#ffffff"
            }
        },
    },

    content: {
        textAlign: "center",
        textDecoration: "none",
        color: "black",
        fontWeight: 700
    },

    icon: {
        minWidth: 100,
        minHeight: 100,
        verticalAlign: "center",
        textDecoration: "none",
        color: "black"
    },

    courseSelectFormControl: {
        margin: theme.spacing(1),
        minWidth: 200,
    },

    courseSelectInputLabel: {
        color: "white",
        fontSize: "18px"
    },

    courseSelect: {

        color: "white",

    },

    tooltipBox: {
        background: "green",
    }

}));

export { useStyles };